package com.tedd.db

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.tedd.db.shared.newInstance
import com.tedd.db.shared.schema
import kotlin.Unit

public interface TeddDatabase : Transacter {
  public val accountQueries: AccountQueries

  public val appPreferenceQueries: AppPreferenceQueries

  public val assetQueries: AssetQueries

  public val assetValuationQueries: AssetValuationQueries

  public val assistantConversationQueries: AssistantConversationQueries

  public val assistantMessageQueries: AssistantMessageQueries

  public val attachmentQueries: AttachmentQueries

  public val categoryQueries: CategoryQueries

  public val competenceQueries: CompetenceQueries

  public val competenceCriterionQueries: CompetenceCriterionQueries

  public val competenceFamilyQueries: CompetenceFamilyQueries

  public val cravingObservationQueries: CravingObservationQueries

  public val expenseEntryQueries: ExpenseEntryQueries

  public val expenseListQueries: ExpenseListQueries

  public val expenseListItemQueries: ExpenseListItemQueries

  public val fileBlobQueries: FileBlobQueries

  public val financeAccountQueries: FinanceAccountQueries

  public val financeCategoryQueries: FinanceCategoryQueries

  public val financeTransactionQueries: FinanceTransactionQueries

  public val flashcardQueries: FlashcardQueries

  public val focusSessionQueries: FocusSessionQueries

  public val keychainQueries: KeychainQueries

  public val keychainItemQueries: KeychainItemQueries

  public val loanQueries: LoanQueries

  public val loanPaymentQueries: LoanPaymentQueries

  public val milestoneQueries: MilestoneQueries

  public val mindMapQueries: MindMapQueries

  public val mindMapNodeQueries: MindMapNodeQueries

  public val mindMapNodeNoteQueries: MindMapNodeNoteQueries

  public val noteQueries: NoteQueries

  public val noteRevisionQueries: NoteRevisionQueries

  public val notebookQueries: NotebookQueries

  public val objectiveQueries: ObjectiveQueries

  public val objectiveProgressHistoryQueries: ObjectiveProgressHistoryQueries

  public val objectiveReflectionQueries: ObjectiveReflectionQueries

  public val organizationQueries: OrganizationQueries

  public val parcoursStepQueries: ParcoursStepQueries

  public val pomodoroCheckQueries: PomodoroCheckQueries

  public val pomodoroItemQueries: PomodoroItemQueries

  public val pomodoroSessionQueries: PomodoroSessionQueries

  public val portfolioPieceQueries: PortfolioPieceQueries

  public val portfolioPieceCompetenceQueries: PortfolioPieceCompetenceQueries

  public val projectQueries: ProjectQueries

  public val projectStatusQueries: ProjectStatusQueries

  public val serverIdMapQueries: ServerIdMapQueries

  public val simulationQueries: SimulationQueries

  public val simulationLineQueries: SimulationLineQueries

  public val skillQueries: SkillQueries

  public val skillResourceQueries: SkillResourceQueries

  public val syncCursorQueries: SyncCursorQueries

  public val syncResetQueries: SyncResetQueries

  public val taskQueries: TaskQueries

  public val timerStateQueries: TimerStateQueries

  public val userProfileQueries: UserProfileQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = TeddDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): TeddDatabase =
        TeddDatabase::class.newInstance(driver)
  }
}
